/**
 * Talent (Professional) dashboard shell with the full Career Suite —
 * Passport, verifications, matches, applications, and AI coaches.
 */
import React from "react";
import { Route, Navigate } from "react-router-dom";

import TalentLayout from "@/pages/talent/TalentLayout";
import TalentDashboard from "@/pages/talent/TalentDashboard";
import TalentPassport from "@/pages/talent/TalentPassport";
import VerifyConsentCenter from "@/pages/talent/VerifyConsentCenter";
import TalentScreeningRequests from "@/pages/talent/TalentScreeningRequests";
import PersonalBackgroundChecks from "@/pages/talent/PersonalBackgroundChecks";
import TalentBilling from "@/pages/talent/TalentBilling";
import JobMatches from "@/pages/talent/JobMatches";
import ApplicationTracker from "@/pages/talent/ApplicationTracker";
import Opportunities from "@/pages/talent/Opportunities";
import JobAlerts from "@/pages/talent/JobAlerts";
import ResumeBuilder from "@/pages/talent/ResumeBuilder";
import InterviewCoach from "@/pages/talent/InterviewCoach";
import CoverLetterGenerator from "@/pages/talent/CoverLetterGenerator";
import SalaryInsights from "@/pages/talent/SalaryInsights";
import CareerCoach from "@/pages/talent/CareerCoach";
import CoachTools from "@/pages/talent/CoachTools";
import TalentBadge from "@/pages/talent/TalentBadge";
import TalentBackgroundChecks from "@/pages/talent/TalentBackgroundChecks";
import TalentMessages from "@/pages/talent/TalentMessages";
import ActivityPage from "@/pages/ActivityPage";

export function talentRoutes() {
    return (
        <Route path="/professional" element={<TalentLayout />}>
            <Route index element={<Navigate to="/professional/dashboard" replace />} />
            <Route path="dashboard" element={<TalentDashboard />} />
            <Route path="passport" element={<TalentPassport />} />
            <Route path="verify" element={<VerifyConsentCenter />} />
            <Route path="screenings" element={<TalentScreeningRequests />} />
            <Route path="personal-checks" element={<PersonalBackgroundChecks />} />
            <Route path="billing" element={<TalentBilling />} />
            <Route path="activity" element={<ActivityPage />} />
            <Route path="matches" element={<JobMatches />} />
            <Route path="applications" element={<ApplicationTracker />} />
            <Route path="messages" element={<TalentMessages />} />
            <Route path="job-alerts" element={<JobAlerts />} />
            <Route path="opportunities" element={<Opportunities />} />
            <Route path="badge" element={<TalentBadge />} />
            <Route path="background-checks" element={<TalentBackgroundChecks />} />
            <Route path="resume" element={<ResumeBuilder />} />
            <Route path="interview-coach" element={<InterviewCoach />} />
            <Route path="cover-letters" element={<CoverLetterGenerator />} />
            <Route path="salary" element={<SalaryInsights />} />
            <Route path="coach" element={<CareerCoach />} />
            <Route path="coach-tools" element={<CoachTools />} />
        </Route>
    );
}
